<template>
    <section class="container">
        <div class="row">
            <div class="col-md-2" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                <adminSidenav></adminSidenav>
            </div>
            <div class="col">
                <div class="container">
                    <h3>공지수정</h3>

                    <div class="">
                        <input type="text" placeholder="제목" class="form-control" ref="title" name="title" v-model="notice.title">
                        <br>
                    </div>
                    <div class="pucheck">
                        <input type="checkbox" v-model="notice.isPopup" class="form-check-input" id="noticePopup">
                        <label class="form-check-label" for="noticePopup">팝업공지</label>
                    </div>
                    <div class="">
                        <div class="quill-editor">
                            <quill-editor style="height: 250px" ref="contents" v-model="notice.content"
                                          :content="notice.content"
                                          :options="editorOption"
                                          @change="onEditorChange($event)">
                            </quill-editor>
                        </div>
                    </div>
                    <div class="text-center">
                        <button type="submit" v-on:click="formSubmit()" class="btn btn-primary">등록</button>
                        <button type="submit" v-on:click="goList()" class="btn btn-primary" >목록</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import { quillEditor } from 'vue-quill-editor'
    import adminSidenav from '@/components/admin/Sidenav.vue'

    export default {
        name: 'NoticeModified',
        components: { quillEditor, adminSidenav },
        data() {
            return {
                notice: {
                    id: '',
                    title: '',
                    content: "",
                    isPopup: false,
                },
                editorOption: {
                    modules: {
                        toolbar: [
                            [{'size': ['small', false, 'large']}],
                            ['bold', 'italic'],
                            [{'list': 'ordered'}, {'list': 'bullet'}],
                            ['link', 'image']
                        ],
                        history: {
                            delay: 1000,
                            maxStack: 50,
                            userOnly: false
                        },
                    },

                    placeholder: '이곳에 입력해 주세요.',
                },
            };
        },

        methods: {
            getContents() {
                let me = this;

                this.axios.get(process.env.VUE_APP_NOTICE_API_URL + `/${me.$route.params.id}`)
                    .then(function (res) {
                        me.notice = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            formSubmit() {
                let me = this;

                this.axios.put(process.env.VUE_APP_NOTICE_API_URL + `/post/${me.$route.params.id}`, this.notice)
                    .then(function (res) {
                        me.notice = res.data;
                        me.$root.$children[0].commonDialog('공지사항','수정 되었습니다.');
                        me.$router.go(-1);
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });
            },
            goList() {
                this.$modal.show('dialog', {
                    text: `목록으로 가시겠습니까? <br/> 작성 중이던 글은 저장되지 않습니다.`,
                    buttons: [
                        {
                            title: '확인',
                            handler: () => {
                                this.$router.push("notice");
                                this.$modal.hide('dialog');
                            }
                        },
                        {
                            title: '취소'
                        },
                    ]
                })
            },
            onEditorChange({quill, html, text}) {
                this.notice.content = html
            },

        },
        mounted() {
            this.getContents();
        },
    }
</script>
<style scoped>
    .quill-editor {
        height: 250px;
        width: 100%;
    }
    .pucheck {
        margin-left: 25px;
    }
    button{
        margin : 10px;
    }
</style>